<template>
    <div style="display: flex;justify-content: center;">
        <div style="max-width: 600px;margin-top: 50px;width: 100%;">
            <div style="display: flex;width: 100%;">
                <el-input v-model="qsyurl" placeholder="请输入链接" clearable style="width:100%;"></el-input>
                <el-button style="margin-left: 5px;" type="primary" @click="qsy">去水映</el-button>
            </div>
            <div v-if="oklist.length != 0">
                <div class="biaoqian">
                    提取结果：
                </div>

                <div style="display: flex;background-color: #f1f1f1;padding: 5px;border-radius: 5px;cursor: pointer;"
                    @click.stop="_copy(oklist.desc)" v-if="oklist.desc">
                    <div style="font-size: 13px;color: #666;">
                        {{ oklist.desc }}
                    </div>
                    <div
                        style="width: 50px;text-align: center;font-size: 12px;align-items: center;color: #000;border-radius: 3px;margin-left: 10px;min-width: 50px;">
                        <i class="el-icon-document-copy"></i>
                        复制
                    </div>
                </div>
                <div style="display: flex;justify-content: center;margin-top: 10px;flex-wrap: wrap;">
                    <video :src="oklist.resource_url" controls="controls" crossorign="Anonymous"
                        style="width: 200px;height: 350px;">
                    </video>
                    <div style="border: 1px dashed #999;margin: 10px;border-radius: 10px;">
                        <div style="margin: 10px;">
                            <div style="margin-top: 10px;font-size: 14px;font-weight: 600;">
                                下载方法
                            </div>
                            <div style="font-size: 13px;margin-top: 10px;">
                                方法一：
                                <div style="margin-top: 10px;">
                                    <el-image style="width: 160px;" :src="require('@/assets/qsyxiazai.png')"></el-image>
                                </div>
                            </div>
                            <!-- <div style="font-size: 13px;margin-top: 20px;">
                                下载方法一：
                                <div style="margin-top: 5px;">
                                    <el-button style="margin-left: 5px;" type="primary" @click="qsy" size="small">下载视频</el-button>
                                </div>
                            </div> -->
                            <div style="font-size: 13px;margin-top: 20px;">
                                方法二：
                                <div style="margin-top: 5px;">
                                    <el-button style="margin-left: 5px;" type="primary" @click.stop="_copy(oklist.resource_url)" size="small">复制下载链接</el-button>
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）

export default {
    name: '',
    components: {

    },
    // 定义属性
    data() {
        return {
            qsyurl: '',
            oklist: []
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        qsy() {
            var data = {
                url: this.qsyurl
            }
			var httpData={
				link:this.qsyurl
			}
			this.$http.post("/api/water/index",httpData).then(res => {
				this.oklist = res
			})
            // this.$ajax.post('qhy/user/qsyjk', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(res => {
            //     console.log(res.data)
            //     var jg = res.data
            //     if (res.data.status == 200) {
            //         this.oklist = res.data.data
            //     } else {
            //         this.$message.error(res.data.msg);
            //     }
            //     loading.close();

            // })
        },
        _copy(context) {
            // 创建输入框元素
            try {
                let oInput = document.createElement('textarea');
                // 将想要复制的值
                oInput.value = context;
                // 页面底部追加输入框
                document.body.appendChild(oInput);
                // 选中输入框
                oInput.select();
                // 执行浏览器复制命令
                document.execCommand('Copy');
                // 弹出复制成功信息
                this.$message.success('复制成功');
                // 复制后移除输入框
                oInput.remove();
            } catch (e) {
                this.$message.error('复制失败,此任务没有原链接');
            }


        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() { }, // 生命周期 - 创建之前
    beforeMount() { }, // 生命周期 - 挂载之前
    beforeUpdate() { }, // 生命周期 - 更新之前
    updated() { }, // 生命周期 - 更新之后
    beforeDestroy() { }, // 生命周期 - 销毁之前
    destroyed() { }, // 生命周期 - 销毁完成
    activated() { }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped></style>